
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsfe989b3d0b05f4ab36b9405b41aae50aen from './en.yaml'
            i18n.addResourceBundle('en', 'fe989b3d0b05f4ab36b9405b41aae50a', flattenObject(nsfe989b3d0b05f4ab36b9405b41aae50aen), true, true);
        
        export default 'fe989b3d0b05f4ab36b9405b41aae50a';
    